import { render } from "./ClientAddJwtBearerModal.vue?vue&type=template&id=2ebc38e5"
import script from "./ClientAddJwtBearerModal.vue?vue&type=script&lang=js"
export * from "./ClientAddJwtBearerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__